import { render, staticRenderFns } from "./alpha-sms.vue?vue&type=template&id=7c439c88&scoped=true&"
import script from "./alpha-sms.vue?vue&type=script&lang=js&"
export * from "./alpha-sms.vue?vue&type=script&lang=js&"
import style0 from "./alpha-sms.vue?vue&type=style&index=0&id=7c439c88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c439c88",
  null
  
)

export default component.exports